import { Download } from '@mui/icons-material';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { useDownload } from '../../../Utils/Download/useDownload';

const ReusableComparisonTable = ({
  tableInfo,
  title = null,
  titleVariant = 'h2',
  headerVariant = 'h3',
  footerVariant = 'p3',
  cellVariant = 'body1',
  tableSx = {},
  headerAlign = 'center',
  firstColAlign = 'start',
  paddingSpace = 2,
  headerCellPadding = 0,
  border = true
}) => {
  const download = useDownload();
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        border: border ? '1px solid #D9D9D9' : 'none',
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',
        padding: paddingSpace,
        ...tableSx,
      }}
    >
      {title && <Typography variant={titleVariant}>{title}</Typography>}
      <Table sx={{ boxShadow: 'none' }}>
        <TableHead>
          <TableRow>
            {tableInfo?.table_header_keys &&
              tableInfo?.table_header_keys.map((header, index) => (
                <TableCell
                  sx={{
                    borderBottom: '1px solid #F2F2F2',
                    textAlign: 'center',
                    padding: headerCellPadding,
                    py: '8px',
                  }}
                  key={index}
                >
                  {header?.logo && (
                    <Box
                      component='img'
                      src={header?.logo}
                      alt='Descriptive alt text'
                      sx={{ height: 32, mb: 0.5 }}
                    />
                  )}
                  <Typography
                    variant={headerVariant}
                    sx={{
                      textAlign: index === 0 ? firstColAlign : headerAlign,
                    }}
                  >
                    {header.label}
                  </Typography>
                  {header?.footer_txt && (
                    <Typography
                      variant={footerVariant}
                      sx={{
                        color: '#666',
                        textAlign: index === 0 ? firstColAlign : headerAlign,
                      }}
                    >
                      {header?.footer_txt}
                    </Typography>
                  )}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {tableInfo?.table_list_dtos &&
            tableInfo?.table_list_dtos.map((row, rowIndex) => {
              const isLastRow =
                rowIndex === tableInfo.table_list_dtos.length - 1;

              return (
                <TableRow key={rowIndex}>
                  {tableInfo?.table_header_keys.map((header, colIndex) => {
                    const cellValue = row[header?.value];
                    const isDownloadLink =
                      typeof cellValue === 'string' &&
                      cellValue.startsWith('http');

                    return (
                      <TableCell
                        key={colIndex}
                        sx={{
                          borderBottom: isLastRow
                            ? 'none'
                            : '1px solid #F2F2F2',
                          fontWeight: 'bold',
                          padding: headerCellPadding,
                          py: '8px',
                        }}
                      >
                        <Box
                          display='flex'
                          alignItems='center'
                          justifyContent={
                            colIndex === 0 ? firstColAlign : headerAlign
                          }
                        >
                          <Typography
                            variant={cellVariant}
                            sx={{ mr: isDownloadLink ? 1 : 0 }}
                          >
                            {isDownloadLink ? '' : cellValue || '-'}
                          </Typography>
                          {isDownloadLink && (
                            <IconButton
                              size='small'
                              download
                              sx={{
                                color: 'primary.main',
                                padding: 0,
                                minWidth: 'auto',
                              }}
                              onClick={() =>
                                download(cellValue, `certificate.pdf`)
                              }
                            >
                              <Download fontSize='small' />
                            </IconButton>
                          )}
                        </Box>
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          {tableInfo?.total && (
            <TableRow>
              {tableInfo?.table_header_keys.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    borderBottom: 'none',
                    fontWeight: 'bold',
                    textAlign: index === 0 ? firstColAlign : headerAlign,
                    borderTop: '1px solid #D9D9D9',
                    padding: headerCellPadding,
                    py: '8px',
                  }}
                >
                  <Typography variant={footerVariant}>
                    {tableInfo.total[header.value] || '-'}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReusableComparisonTable;
